// Vue
import Vue from 'vue';
window.Vue = Vue;

// Vue Router
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import TextGen from '@/utilities/TextGen'
window.TextGen = TextGen

// App
let isAllegra = location.href.includes('allegra')
if(process.env.VUE_APP_ALLEGRA === 'true') {
    isAllegra = true
} else if(process.env.VUE_APP_ALLEGRA === 'false') {
    isAllegra = false
}

Object.defineProperty(Vue.prototype, 'isAllegra', { value: isAllegra });
window.isAllegra = isAllegra

// AppStorage
import AppStorage from '@/wrappers/AppStorage';
window.AppStorage = AppStorage

// Api Service
import ApiService from '@/services/ApiService';
ApiService.init(isAllegra ? process.env.VUE_APP_ALLEGRA_API_URL : process.env.VUE_APP_ARIA_API_URL);
window.ApiService = ApiService;

// Create a global event bus
window.EventBus = new Vue();
Object.defineProperty(Vue.prototype, 'eventBus', { value: EventBus });

// Load Printing Utilities
import PrintService from '@/print/PrintService';
Object.defineProperty(Vue.prototype, '$printService', { value: PrintService });
window.PrintService = PrintService;

// Lodash
import lodash from 'lodash';
Object.defineProperty(Vue.prototype, '_', { value: lodash });
window._ = lodash;

// Money
import Money from '@/wrappers/Money'
window.Money = Money;
Object.defineProperty(Vue.prototype, 'Money', { value: Money });

// Moment
// import * as moment from 'dayjs';
// import * as utc from 'dayjs/plugin/utc';
// import * as timezone from 'dayjs/plugin/timezone';
// import * as duration from 'dayjs/plugin/duration';
// import * as customParseFormat from 'dayjs/plugin/customParseFormat';
// import * as isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
// import * as isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
// import * as isoWeek from 'dayjs/plugin/isoWeek';
// moment.extend(utc);
// moment.extend(timezone);
// moment.extend(duration);
// moment.extend(customParseFormat);
// moment.extend(isSameOrBefore);
// moment.extend(isSameOrAfter);
// moment.extend(isoWeek);

import moment from 'moment-timezone';

Object.defineProperty(Vue.prototype, 'moment', { value: moment });
window.moment = moment;

// HashGen
import HashGen from '@/utilities/HashGen';
window.HashGen = HashGen;

// Bcrypt
let bcrypt = require('bcryptjs');
window.bcrypt = bcrypt;

// ApexCharts
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

// Paddle
if(window.Paddle && process.env.VUE_APP_ENABLE_BILLING === 'true' && process.env.VUE_APP_PADDLE_VENDOR_ID) {
    window.Paddle.Setup({ vendor: parseInt(process.env.VUE_APP_PADDLE_VENDOR_ID) });
}

// Font Awesome
import './lib/fontawesome/css/all.css';

// InteractJs
window.interact = require('interactjs');

// Form utilities
import CodForm from '@/forms/CodForm';
Object.defineProperty(Vue.prototype, 'CodForm', { value: CodForm });
window.CodForm = CodForm;

// Form utilities - New
import Form from '@/forms/Form';
Object.defineProperty(Vue.prototype, 'Form', { value: Form });
window.Form = Form;

// Load Models
import * as models from '@/models/ModelRepository'

for(const model in models) {
    window[model] = models[model]
}

// Vue Tour
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

// QR Code
import VueQrcode from '@chenfengyuan/vue-qrcode';
Vue.component(VueQrcode.name, VueQrcode);

// Update main HTML page
document.querySelector('#manifest-el').setAttribute('href', `/${isAllegra ? 'allegra-manifest' : 'aria-manifest'}.json`);
document.querySelector('#favicon-el').setAttribute('href', `/img/${isAllegra ? 'allegra' : 'aria'}/icons/favicon-32x32.png`);
document.title = isAllegra ? 'Allegra POS' : 'Aria POS'

import PrintGen from '@/utilities/PrintGen'
window.PrintGen = PrintGen

// Error Handling
import ErrorReporter from '@/wrappers/ErrorReporter';
ErrorReporter.init()
ErrorReporter.setUpErrorReporting()
window.ErrorReporter = ErrorReporter

// Vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// VMask
import VueMask from 'v-mask'
Vue.use(VueMask)

// Fiscal Service
import FiscalService from '@/services/FiscalService';
window.FiscalService = FiscalService

// Fiscal Service Legacy
import FiscalServiceLegacy from '@/services/FiscalServiceLegacy';
window.FiscalServiceLegacy = FiscalServiceLegacy

// Log Service
import LogService from '@/services/LogService';
window.LogService = LogService
